module.exports = __webpack_public_path__ + "dc7bcec22ca2fd04d6d1a43504e426ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner-image-desktop.jpg
// module id = 109
// module chunks = 0